<template>
  <v-footer fixed color="primary">
    <v-container fluid>
      <v-row>
        <v-col cols="12" sm="3" offset-sm="2">
          <v-list color="primary" dark>
            <v-list-item>
              <NishikaLogo white />
            </v-list-item>
            <v-list-item>
              <v-row>
                <v-col cols="2">
                  <ExternalLink
                    to="https://www.facebook.com/nishika0507/"
                    style="text-align: right"
                    target="_blank"
                  >
                    <v-icon>mdi-facebook</v-icon>
                  </ExternalLink>
                </v-col>
                <v-col cols="2">
                  <ExternalLink to="https://twitter.com/Nishika0507" target="_blank">
                    <v-icon>mdi-twitter</v-icon>
                  </ExternalLink>
                </v-col>
                <v-col cols="2">
                  <ExternalLink to="https://note.com/nishika_inc" target="_blank">
                    <img src="@/assets/note_logo.png" width="26"/>
                  </ExternalLink>
                </v-col>
              </v-row>
            </v-list-item>
          </v-list>
        </v-col>
        <v-col cols="12" sm="3">
          <v-list color="primary">
            <v-list-item>
              <ExternalLink white to="https://info.nishika.com/" target="_blank">{{label("company")}}</ExternalLink>
            </v-list-item>
            <v-list-item  v-if="!isClient">
              <ExternalLink white to="https://info.nishika.com/recruit" target="_blank">{{label("recruit")}}</ExternalLink>
            </v-list-item>
            <v-list-item>
              <ExternalLink white :to="toNishika('/inquiry')" target="_blank">{{label("inquiry")}}</ExternalLink>
            </v-list-item>
            <v-list-item>
              <ExternalLink white :to="toNishika('/terms')" target="_blank">{{label("term")}}</ExternalLink>
            </v-list-item>
            <v-list-item>
              <ExternalLink white :to="toNishika('/privacy')" target="_blank">{{label("privacy")}}</ExternalLink>
            </v-list-item>
          </v-list>
        </v-col>
        <v-col cols="12" sm="3">
          <v-list color="primary">
            <v-list-item>
              <ExternalLink white :to="toNishika('/privacy-policy')">個人情報保護方針</ExternalLink>
            </v-list-item>
            <v-list-item>
              <ExternalLink white :to="toNishika('/privacy-policy#purpose')">個人情報の利用目的</ExternalLink>
            </v-list-item>
            <v-list-item>
              <ExternalLink white :to="toNishika('/privacy-policy#procedures')">個人情報開示等のご請求手続きについて</ExternalLink>
            </v-list-item>
            <v-list-item>
              <ExternalLink white :to="toNishika('/privacy-policy#contact')">個人情報に関する苦情及び相談受付窓口</ExternalLink>
            </v-list-item>
          </v-list>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="footer__copyright">©︎ 2019 - {{currentYear}} Nishika, Inc.</v-col>
      </v-row>
    </v-container>
  </v-footer>
</template>

<script>
import ExternalLink from "../atoms/ExternalLink";
import NishikaLogo from "../atoms/NishikaLogo";
import ComponentMixin from "../ComponentMixin";
export default {
  mixins: [ComponentMixin],
  type: "organism",
  name: "Footer",
  components: {
    NishikaLogo,
    ExternalLink,
  },
  computed: {
    isClient () {
      if (this.$route.path.indexOf('/clients') == 0) {
        return true;
      }
      return false;
    },
    currentYear() {
      const today = new Date()
      return today.getFullYear()
    },
  },
};
</script>

<style scoped lang="sass">
.footer__copyright
  color: #ffffff
  font-size: 12px
  text-align: center

.v-list-item
  min-height: 30px
  padding-bottom: 5px
</style>
